import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratosVigentes() {
        let url = `${api}/contratos`
        return axiosJwt
            .post(url, null)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterContratosPorId(contratoId) {
        let url = `${api}/contratos/${contratoId}`
        return axiosJwt
            .get(url)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    obterFonteDeReferencias() {
        return new Promise((resolve) => {
            resolve({
                success: true,
                data: [
                    { codigo: 'CATMAT', nome: 'CATMAT' },
                    { codigo: 'CATSER', nome: 'CATSER' },
                    { codigo: 'COLETA', nome: 'COLETA' },
                    { codigo: 'COMPESA', nome: 'COMPESA' },
                    { codigo: 'COMPOSICAO', nome: 'COMPOSICAO' },
                    { codigo: 'DER', nome: 'DER' },
                    { codigo: 'DNIT', nome: 'DNIT' },
                    { codigo: 'EMLURB', nome: 'EMLURB' },
                    { codigo: 'ORSE', nome: 'ORSE' },
                    { codigo: 'PINI', nome: 'PINI' },
                    { codigo: 'SEDUC', nome: 'SEDUC' },
                    { codigo: 'SEINFRA-CE', nome: 'SEINFRA-CE' },
                    { codigo: 'SINAPI-N', nome: 'SINAPI-N' }
                ]
            })
        })
    },

    obterListaIndiceAtualizacoes() {
        return new Promise((resolve) => {
            resolve({
                success: true,
                data: [
                    { nome: '', codigo: '' },
                    {
                        nome: 'ADMINISTRAÇÃO LOCAL (DNIT)',
                        codigo: 'ADMINISTRAÇÃO LOCAL'
                    },
                    {
                        nome: 'Asfalto Diluído - DNIT',
                        codigo: 'ASFALTO DILUÍDO'
                    },
                    {
                        nome: 'Cimento Asfáltico Petróleo (CAP 7 e 20) - DNIT',
                        codigo: 'CIMENTO ASFÁLTICO PETRÓLEO (CAP 7 e 20)'
                    },
                    {
                        nome: 'Conservação Rodoviária (FGV - col. 39D)',
                        codigo: 'CONSERVAÇÃO RODOVIÁRIA'
                    },
                    {
                        nome: 'Consultoria (FGV - col. 39)',
                        codigo: 'CONSULTORIA (SUPERVISÃO E PROJETOS)'
                    },
                    { nome: 'Drenagem (FGV - col. 39A)', codigo: 'DRENAGEM' },
                    {
                        nome: 'Emulsões (RR1C e RR2C) - DNIT',
                        codigo: 'EMULSÕES (RR1C E RR2C)'
                    },
                    {
                        nome: 'Índice Geral de Preços - Disponibilidade Interna',
                        codigo: 'IGP-DI'
                    },
                    {
                        nome: 'Índice Geral de Preços - Mercado (FGV)',
                        codigo: 'IGP-M'
                    },
                    {
                        nome: 'Índice Nacional da Construção Civil',
                        codigo: 'INCC'
                    },
                    {
                        nome: 'ÍNDICE DE ASFALTO BORRACHA (DNIT)',
                        codigo: 'ÍNDICE DE ASFALTO BORRACHA'
                    },
                    {
                        nome: 'ÍNDICE DE ASFALTO MODIFICADO POR POLÍMERO (DNIT)',
                        codigo: 'ÍNDICE DE ASFALTO MODIFICADO POR POLÍMERO'
                    },
                    {
                        nome: 'ÍNDICE DE EMULSÃO ASFÁLTICA DE IMPRIMAÇÃO (DNIT)',
                        codigo: 'ÍNDICE DE EMULSÃO ASFÁLTICA DE IMPRIMAÇÃO'
                    },
                    {
                        nome: 'ÍNDICE DE EMULSÃO ASFÁLTICA MODIFICADO (DNIT)',
                        codigo: 'ÍNDICE DE EMULSÃO ASFÁLTICA MODIFICADO'
                    },
                    {
                        nome: 'Índice Nacional de Preços ao Consumidor (IBGE)',
                        codigo: 'INPC'
                    },
                    {
                        nome: 'Índice Nacional de Preços ao Consumidor Amplo (IBGE)',
                        codigo: 'IPCA'
                    },
                    {
                        nome: 'Ligantes Betuminosos (FGV - col. 39E)',
                        codigo: 'LIGANTES BETUMINOSOS'
                    },
                    {
                        nome: 'MOBILIZAÇÃO E DESMOBILIZAÇÃO (DNIT)',
                        codigo: 'MOBILIZAÇÃO E DESMOBILIZAÇÃO'
                    },
                    {
                        nome: 'OBRAS COMPLEMENTARES E MEIO AMBIENTE (DNIT)',
                        codigo: 'OBRAS COMPLEMENTARES E MEIO AMBIENTE'
                    },
                    {
                        nome: 'OBRAS DE ARTE ESPECIAIS (FGV - col. 36)',
                        codigo: 'OBRAS DE ARTE ESPECIAIS'
                    },
                    {
                        nome: 'OBRAS DE ARTE ESPECIAIS (SEM AÇO)',
                        codigo: 'OBRAS DE ARTE ESPECIAIS (Sem Aço)'
                    },
                    {
                        nome: 'OBRAS DE ARTE ESPECIAIS (Sem Aço) - DNIT',
                        codigo: 'OBRAS DE ARTE ESPECIAIS (SEM AÇO)'
                    },
                    {
                        nome: 'OBRAS PORTUÁRIAS (CONSULTORIA) - DNIT',
                        codigo: 'OBRAS PORTUÁRIAS (CONSULTORIA)'
                    },
                    {
                        nome: 'Pavimentação (FGV - col. 37)',
                        codigo: 'PAVIMENTAÇÃO'
                    },
                    {
                        nome: 'Pavimentos de Concreto de Cimento Portland (FGV - col. 39C)',
                        codigo: 'PAVIMENTOS CONCRETO CIMENTO PORTLAND'
                    },
                    {
                        nome: 'PRODUTOS DE AÇO GALVANIZADO (DNIT)',
                        codigo: 'PRODUTOS DE AÇO GALVANIZADO'
                    },
                    {
                        nome: 'PRODUTOS SIDERÚRGICOS (DNIT)',
                        codigo: 'PRODUTOS SIDERÚRGICOS'
                    },
                    {
                        nome: 'SERVIÇOS COM AÇO PARA OBRAS DE ARTE ESPECIAIS',
                        codigo: 'SERVIÇOS COM AÇO PARA OBRAS DE ARTE ESPECIAIS'
                    },
                    {
                        nome: 'Sinalização Horizontal (FGV - col. 39B)',
                        codigo: 'SINALIZAÇÃO HORIZONTAL'
                    },
                    {
                        nome: 'SINALIZAÇÃO VERTICAL (DNIT)',
                        codigo: 'SINALIZAÇÃO VERTICAL'
                    },
                    {
                        nome: 'Índice SINAPI - IBGE (BRASIL - Custo Médio em R$/m² sem desoneração)',
                        codigo: 'SINAPI'
                    },
                    {
                        nome: 'SUPERESTRUTURA DE PASSARELAS METÁLICAS',
                        codigo: 'SUPERESTRUTURA DE PASSARELAS METÁLICAS'
                    },
                    {
                        nome: 'Terraplenagem (FGV - col. 38)',
                        codigo: 'TERRAPLENAGEM'
                    },
                    {
                        nome: 'VERGALHÕES E ARAMES DE AÇO CARBONO (DNIT)',
                        codigo: 'VERGALHÕES E ARAMES DE AÇO CARBONO'
                    }
                ]
            })
        })
    },

    obterListaTipoBenefico() {
        return new Promise((resolve) => {
            resolve({
                success: true,
                data: [
                    { nome: 'Participação exclusiva para ME/EPP', codigo: '1' },
                    { nome: 'Subcontratação para ME/EPP', codigo: '2' },
                    { nome: 'Cota reservada para ME/EPP', codigo: '3' },
                    { nome: 'Sem benefício', codigo: '4' },
                    { nome: 'Não se aplica', codigo: '5' }
                ]
            })
        })
    },

    validarCodigoReferencia() {
        let url = `https://sistemas.tce.pe.gov.br/DadosAbertos/CodigoReferencia!json?FonteReferencia=d&DataReferencia=01/01/2025&CodigoReferencia=r&Descricao=d`
        return axiosJwt
            .get(url)
            .then((response) => {
                return response.status === 'OK'
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    GerarPlanilhaRelatorioContratoLai(dadosComplementares) {
        return axiosJwt
            .post(
                `${api}/contratos/relatorios/gestaojuridica/contrato-lai`,
                dadosComplementares
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    GerarPlanilhaRelatorioContratoIj(dadosPlanilha) {
        return axiosJwt
            .post(
                `${api}/contratos/relatorios/gestaojuridica/contrato-ij`,
                dadosPlanilha
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },

    GerarPlanilhaRelatorioOrcamentoResultados(dadosPlanilha) {
        return axiosJwt
            .post(
                `${api}/contratos/relatorios/gestaojuridica/orcamento-resultado`,
                dadosPlanilha
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    }
}
